module.exports = __webpack_public_path__ + "img/microgaming.b14cf63d.svg";